module.exports = __webpack_public_path__ + "img/waimai-02.eb1834ab.jpg";